module.exports = __webpack_public_path__ + "img/LTS_NB.46be2f4e.gif";